import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import backBtn from "../assets/icons/back-btn.png";
import logo from "../assets/doctio-logo.svg";
import fraseIkon from "../assets/icons/Paper-icon + circle.svg";
import sygeplejerske from "../assets/people/TBV03928.png";
import { ToastContainer } from "react-toastify";
import { StatsData } from "../types/Signup/SignUpStep";
import Stats from "../components/Stats/Stats";

export default function PaymentConfirmation() {
  const navigate = useNavigate();
  const location = useLocation();
  const [statsData, setStatsData] = useState<StatsData>({
    doctor: 0,
    medstudent: 0,
    nurse: 0,
    other: 0,
  });

  const { isPro } = location.state || {};

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          "https://test.doctio.dk/api/statistics/professions"
        );
        const jsonData = await response.json();
        setStatsData(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, []);

  return (
    <div>
      <section className="md:h-screen">
        <div className="grid mx-auto h-full md:grid-cols-2">
          <div className="bg-white container md:w-2/3 mx-auto w-full md:py-6 order-2 md:order-1">
            <div className="header mt-2 hidden md:block flex items-center justify-between md:block">
              <button
                className="flex items-center md:mb-24"
                onClick={() => navigate(-1)}
              >
                <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
                <p className="text-doctio-green">Tilbage</p>
              </button>
              <img
                src={logo}
                width={150}
                className="md:mr-3 md:mb-20"
                alt="Logo"
              />
            </div>

            <h1 className="text-dxl font-bold leading-tight tracking-tight text-doctio-green md:text-d2xl">
              {isPro ? "Vi har modtaget dit køb" : "Tak, du er oprettet."}
            </h1>

            <p>
              {isPro ? (
                <>
                  Tak for du har valgt Doctio. Vi har sendt dig en mail med
                  kvitteringen for dit køb.
                  <br />
                  <br />
                </>
              ) : (
                ""
              )}
              Du kan nu gå i gang med at bruge Doctio. Du kan logge ind ved at
              klikke på knappen neden for.
              <br />
              <br />
              Har du spørgsmål til din ordre, kan du kontakte os på{" "}
              <a
                href="mailto:kontakt@doctio.dk
                "
                className="text-doctio-green underline"
              >
                kontakt@doctio.dk
              </a>
            </p>
            <ToastContainer />

            <Link to="/login">
              <button
                type="button"
                className="text-white transition-colors mt-10 mb-10 w-full duration-300 ease-in-out font-bold rounded-full bg-doctio-green hover:bg-white hover:text-doctio-green hover:shadow-md focus:ring-4 focus:outline-none px-4 py-4 text-center mr-3 md:mr-0"
              >
                Gå i gang
              </button>
            </Link>
          </div>
          <div className="relative mx-auto w-full md:max-w-none container md:bg-doctio-lightgreen md:py-40 md:h-screen order-1 md:order-2 overflow-hidden">
            <div className="shadow-right"></div>
            <div className="md:w-2/3 mx-auto">
              <div className="image-container relative">
                <div className="header mt-4 mb-4 md:hidden flex items-center justify-between md:block">
                  <img
                    src={logo}
                    width={150}
                    className="md:mr-3 md:mb-20"
                    alt="Logo"
                  />
                  <button
                    className="flex items-center md:mb-8"
                    onClick={() => navigate(-1)}
                  >
                    <img
                      src={backBtn}
                      width={26}
                      className="mr-3"
                      alt="Tilbage"
                    />
                    <p className="text-doctio-green">Tilbage</p>
                  </button>
                </div>
                <img
                  src={sygeplejerske}
                  className="mr-3 w-full object-fit mb-10 md:block shadow rounded-3xl"
                  alt="Sygeplejerske"
                />

                <div className="mt-12 mb-10 hidden md:block">
                  <p className="leading-tight tracking-tight">
                    <span className="font-bold">Navn Navnesen</span>, Titel lige
                    her, Hospitalsnavn.
                  </p>
                  <p className="mt-2 italic">Bruger af Doctio</p>
                </div>

                <div className="absolute hidden frase-ikon-sign md:block left-[-95px] top-[265px]">
                  <img
                    src={fraseIkon}
                    width={199}
                    className="mr-3"
                    alt="Fraseikon"
                  />
                </div>
              </div>
              <Stats data={statsData} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
